import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import translationEN from "./locales/en.json";
import translationIT from "./locales/it.json";
import translationDE from "./locales/de.json";
import translationES from "./locales/es.json";
import translationFR from "./locales/fr.json";
import translationPT from "./locales/pt.json";

const resources = {
    "en": {
        translation: translationEN
    },
    "it" : {
        translation: translationIT
    },
    "de": {
        translation: translationDE
    },
    "es": {
        translation: translationES
    },
    "fr": {
        translation: translationFR
    },
    "pt": {
        translation: translationPT
    }
    
};
// don't want to use this?
// have a look at the Quick start guide 
// for passing in lng and translations on init

i18n
    // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
    // learn more: https://github.com/i18next/i18next-http-backend
    // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        lng: 'it',
        fallbackLng: localStorage.getItem("i18nextLng") || 'it-IT',
        debug: true,
        resources,
        interpolation: {
            escapeValue: true, // not needed for react as it escapes by default
        },
        //reloadOnLanguageChange: false

        //lng: 'en',
        ////backend: {
        ////    /* translation file path */
        ////    loadPath: `${process.env.PUBLIC_URL}/assets/data/locales/{{lng}}.json`
        ////},
        //fallbackLng: 'en',
        //debug: true,
        //keySeparator: false,
        //react: {
        //    useSuspense: false
        //},
        //interpolation: {
        //    escapeValue: false,
        //    formatSeparator: ','
        //}
    });


export default i18n;